import classNames from "classnames";
import { twJoin, twMerge } from "tailwind-merge";

function cn(...args: (string | undefined | null | false)[]) {
  return twMerge(classNames(args));
}

export function join(...args: (string | undefined | null | false)[]) {
  return twJoin(classNames(args));
}

export default cn;
